import React from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';

import { getStore } from '../../../../common/redux/store-utils';

import ActivateUserPanel from './components/Panel';
import AuthScreenLayout from '../../components/AuthScreenLayout';
import { registerState } from '../../../../common/Services/RegistrationService.js';
import ActivateUserPanelActions from './redux/actions';

import { isSupportedBrowser } from '../../common/utils';
import UnsupportedBrowsers from '../../components/UnsupportedBrowsers';

const namespace = 'activateUserPanel';
const FORM_ID = 'activateUserForm';
import reducer from './redux/reducer';
import saga from './redux/sagas';

const store = getStore();

const createActivateUserScreen = ({ userId, userEmail, userRoles }) => {
  const domId = 'activateUserPanel';
  if (isSupportedBrowser()) {
    registerState({
      namespace,
      reducers: reducer,
      sagas:    [saga],
    });

    const isSupportUser = userRoles.filter(role => -1 !== ['ROLE_ROOT', 'ROLE_SUPPORT'].indexOf(role)).length >= 1;
    store.dispatch(ActivateUserPanelActions.bootstrap(userId, userEmail, isSupportUser));

    ReactDOM.render(
      <Provider store={store}>
        <AuthScreenLayout>
          <ActivateUserPanel />
        </AuthScreenLayout>
      </Provider>,
      document.getElementById(domId)
    );
  } else {
    ReactDOM.render(<UnsupportedBrowsers />, document.getElementById(domId));
  }
};

window.createActivateUserScreen = createActivateUserScreen;
export { namespace, FORM_ID };
